// src/contexts/AuthProvider.jsx
import React, { createContext, useEffect, useState } from "react";
import SignIn from "../Components/SignIn";
import { useAuth } from "../hooks/use-auth";
import { getAgentRTM,getToken } from "../utils/chat-sdk"; // <-- 改为新版 RTM 客户端
import { setAccessNameStore } from "../utils/store";

export const AuthContext = createContext({});

const AuthProvider = ({ children }) => {
  const {
    isLoggedIn,
    accessToken,
    isLoading: authLoading,
    error,
    signInWithPopup,
    accountDetails,
  } = useAuth();

  const [isSDKReady, setIsSDKReady] = useState(false);
  const isLoading = authLoading || (isLoggedIn && !isSDKReady);

  // 1) 登录成功后连接 RTM，销毁时断开连接
  useEffect(() => {
    let isMounted = true

    const initRTM = async () => {
      try {
        if (isLoggedIn && accessToken) {
          const agentRTM=getAgentRTM()
          console.log("login-----",accessToken)
          await agentRTM.connect(); 
          const sessionUser = await agentRTM.login();
    
          setAccessNameStore(sessionUser?.my_profile?.id)
          
          if (isMounted) setIsSDKReady(true)
        }
      } catch (e) {
        console.error('RTM 初始化失败:', e)
      }
    }

    initRTM()

    return () => {
      isMounted = false
      // 可选：断开 RTM 或清理状态
      // agentRTM.logout()
    }
  }, [isLoggedIn]);


  return (
    <AuthContext.Provider value={accountDetails}>
      {isLoggedIn && isSDKReady  ? (
        children
      ) : (
        <SignIn
          isLoading={isLoading}
          error={error}
          openPopup={signInWithPopup}
        />
      )}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
